(function siteHeaderHeight($, Drupal) {
  Drupal.behaviors.rutherfordSiteHeaderHeight = {
    root: document.documentElement,
    setHeight() {
      const siteHeaderInnerHeight = document.getElementById('site-header-inner')
        .clientHeight;
      const headerHeight = document.getElementById('site-header').clientHeight;
      this.root.style.setProperty(
        '--site-header-inner-height',
        `${siteHeaderInnerHeight}px`,
      );
      this.root.style.setProperty('--site-header-height', `${headerHeight}px`);
    },
    getHeaderFooterMenusHeight() {
      const siteHeaderFooterMenusHeight = document.querySelector(
        '.site-header-footer-menus',
      ).clientHeight;
      this.root.style.setProperty(
        '--site-header-footer-menus-height',
        `${siteHeaderFooterMenusHeight}px`,
      );
    },
  };
})(jQuery, Drupal);
